// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  position: static;
  width: auto;
  height: auto;
  inset: 0;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loading-center {
  justify-content: center;
  align-items: center;
  text-align: center;
}

.loading-center .loading-text {
  margin-top: 20px;
  color: #333;
  font-size: 1.25em;
}
.loading-center .svg-background {
  position: relative;
  width: 100px;
  height: 100px;
}

.svg-background span {
  width: 3vmin;
  height: 6vmin;
  border-radius: 3vmin;
  backface-visibility: hidden;
  position: absolute;
  animation-name: move;
  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);
  animation-iteration-count: infinite;
  animation-duration: 3s;
  top: calc(50% - 3vmin);
  left: 50%;
  transform-origin: -3vmin center;
}
.svg-background span:nth-child(1) {
  background: #02bfff;
  animation-delay: -0.5s;
  opacity: 0;
}
.svg-background span:nth-child(2) {
  background: #19608f;
  animation-delay: -1s;
  opacity: 0;
}
.svg-background span:nth-child(3) {
  background: #7db7cc;
  animation-delay: -1.5s;
  opacity: 0;
}
.svg-background span:nth-child(4) {
  background: #19608f;
  animation-delay: -2s;
  opacity: 0;
}
.svg-background span:nth-child(5) {
  background: #7db7cc;
  animation-delay: -2.5s;
  opacity: 0;
}
.svg-background span:nth-child(6) {
  background: #19608f;
  animation-delay: -3s;
  opacity: 0;
}

@keyframes move {
  0% {
    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);
  }
  30% {
    opacity: 1;
  }
  100% {
    z-index: 10;
    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/loadingSvg/loadingSvg2.scss"],"names":[],"mappings":"AACA;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EAEA,QAAA;EAGA,aAAA;EAGA,0CAAA;EAGA,0BAAA;EAGA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAVF;;AAcA;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;AAXF;;AAkBE;EACE,gBAAA;EACA,WAAA;EACA,iBAAA;AAfJ;AAkBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;AAhBJ;;AAwBA;EACE,YAHe;EAIf,aAAA;EACA,oBALe;EAMf,2BAAA;EACA,kBAAA;EACA,oBAAA;EACA,uDAAA;EACA,mCAAA;EACA,sBAbkB;EAclB,sBAAA;EACA,SAAA;EACA,+BAAA;AArBF;AA8BE;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AA5BJ;AAyBE;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAvBJ;AAoBE;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AAlBJ;AAeE;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAbJ;AAUE;EACE,mBAAA;EACA,sBAAA;EACA,UAAA;AARJ;AAKE;EACE,mBAAA;EACA,oBAAA;EACA,UAAA;AAHJ;;AAQA;EACE;IACE,uDAAA;EALF;EAQA;IACE,UAAA;EANF;EASA;IACE,WAAA;IACA,yDAAA;EAPF;AACF","sourcesContent":["// New class for the full-screen overlay\n.loading-overlay {\n  // Pin the container to the viewport\n  position: static;\n  width: auto;\n  height: auto;\n  // Make it cover the entire screen\n  inset: 0; // Shorthand for top: 0, right: 0, bottom: 0, left: 0\n\n  // Ensure it's on top of all other content\n  z-index: 9999;\n\n  // Add a semi-transparent background to dim the page content\n  background-color: rgba(255, 255, 255, 0.8);\n\n  // Use a backdrop filter for a modern \"glassmorphism\" effect (optional)\n  backdrop-filter: blur(4px);\n\n  // Use the existing flex properties to center the content within the overlay\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n\n.loading-center {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n}\n\n// This class will be stored in npm cache - run npm cache clear --force for every change made to this file\n.loading-center {\n\n  // Move styles specific to the loader itself in here\n  .loading-text {\n    margin-top: 20px;\n    color: #333;\n    font-size: 1.25em;\n  }\n\n  .svg-background {\n    position: relative;\n    width: 100px;\n    height: 100px;\n  }\n}\n\n$animationDuration: 3s;\n$amount: 6;\n$particleRadius: 3vmin; // size of loader circle\n\n.svg-background span {\n  width: $particleRadius;\n  height: $particleRadius * 2;\n  border-radius: $particleRadius;\n  backface-visibility: hidden;\n  position: absolute;\n  animation-name: move;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 0.8);\n  animation-iteration-count: infinite;\n  animation-duration: $animationDuration;\n  top: calc(50% - #{$particleRadius});\n  left: 50%;\n  transform-origin: ($particleRadius*-1) center;\n\n  $colors: (\n    #19608f,\n    #02bfff,\n    #7db7cc,\n  );\n\n@for $i from 1 through $amount {\n  &:nth-child(#{$i}) {\n    background: nth($colors, random(length($colors)));\n    animation-delay: calc($i / $amount) * $animationDuration * -1;\n    opacity: 0;\n  }\n}\n}\n\n@keyframes move {\n  0% {\n    transform: scale(1) rotate(0deg) translate3d(0, 0, 1px);\n  }\n\n  30% {\n    opacity: 1;\n  }\n\n  100% {\n    z-index: 10;\n    transform: scale(0) rotate(360deg) translate3d(0, 0, 1px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
